var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"preview-scale"},[_c('Icon',{attrs:{"path":"preview","name":"search"}}),_c('PreviewProgress',{attrs:{"type":"scale"},on:{"change":_vm.handleChangeScale}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }